module.exports = __webpack_public_path__ + "img/ear03.4a55bd67.png";